<template>
  <div class="relative">
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 shadow-xl overflow-hidden 2xl:border-8 2xl:border-white">
      <div
        v-for="(photo, index) in photoData"
        :key="photo.id"
        class="w-full aspect aspect-w-10 aspect-h-10 bg-cover bg-center cursor-pointer shadow-[0_0_0_1px_rgba(255,255,255,1)]"
        :class="{ 'hidden md:block': index > 4, 'md:hidden': index > 10 }"
        v-lazy:background-image="photo.url.replace('http:', 'https:')"
        @click="openPhoto(index)"
      ></div>
      <div
        tabindex="0"
        @click="openPhoto(0)"
        class="bg-blue flex items-center justify-center text-white font-bold cursor-pointer hover:bg-blue-dark">
        view all<br>
        {{ photoData.length }} photos
      </div>
    </div>

    <teleport to="#popup-target">
      <div v-if="popupOpen" class="fixed z-50 top-0 h-screen w-full bg-white bg-opacity-80 flex flex-col justify-center" >
        <div class="w-full h-full flex flex-col">

          <span @click="popupOpen = false" class="absolute text-white flex items-center leading-none h-10 px-6 bg-blue border-4 border-white shadow-xl right-4 top-4 lg:right-8 cursor-pointer uppercase text-sm" >
            <svg-vue icon="times" class="fill-current h-4 w-4 mr-2"></svg-vue>
            close
          </span>

          <div class="flex-grow lg:h-full w-full flex justify-center items-center py-20 lg:py-8">
          <img :src="activePhoto.url.replace('http:', 'https:')" :alt="activePhoto.name" class="max-h-full max-w-full mx-auto shadow-xl" >
          </div>

          <div class="relative w-full max-w-xs mx-auto bg-white shadow-xl flex justify-between mt-4 lg:-mt-16 p-1 z-20 mb-16" >
            <span @click="prevPhoto" class="leading-none h-10 px-6 bg-blue text-white flex items-center cursor-pointer uppercase text-sm" >
              <svg-vue icon="angle-left" class="fill-current h-4 w-4 mr-2"></svg-vue>
              <span class="sr-only">prev</span>
            </span>
            <span class="text-blue font-bold flex items-center leading-none"> {{ activeIndex + 1 }} of {{ photoData.length }}</span>
            <span @click="nextPhoto" class="leading-none h-10 px-6 bg-blue text-white flex items-center cursor-pointer uppercase text-sm" >
              <span class="sr-only">next</span>
              <svg-vue icon="angle-right" class="fill-current h-4 w-4 ml-2"></svg-vue>
            </span>
          </div>

        </div>

      </div>
    </teleport>
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PropertyPhotoGallery',

  props: {
    photos: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      activePhoto: {},
      photoData: [],
      popupOpen: false,
      activeIndex: 0
    }
  },

  mounted () {
    this.photoData = this.photos
  },

  methods: {
    openPhoto (num) {
      this.popupOpen = true
      this.activeIndex = num
      this.activePhoto = this.photoData[num]
    },

    nextPhoto () {
      if((this.activeIndex+1) == this.photoData.length){
        this.activeIndex = 0
      } else {
        this.activeIndex++
      }

      this.openPhoto(this.activeIndex)
    },

    prevPhoto () {
      if((this.activeIndex+1) == 1){
        this.activeIndex = this.photoData.length
      } else {
        this.activeIndex--
      }

      this.openPhoto(this.activeIndex)
    }
  }

})
</script>
